import { UIProvider } from '@doger/ui/provider';

import { AnalyticsProvider } from '../shared/analytics';
import { I18nProvider } from '../shared/i18n';
import { QueryProvider } from './providers/query.provider';

const AppProviders = ({ children }: { children: React.ReactNode }) => (
  <QueryProvider>
    <I18nProvider supportedLanguages={['en', 'uk']}>
      <UIProvider>
        <AnalyticsProvider>{children}</AnalyticsProvider>
      </UIProvider>
    </I18nProvider>
  </QueryProvider>
);

export { AppProviders };
